import StepCompletionCard from '@cohort/merchants/apps/StepCompletionCard';
import {usePerkAccess} from '@cohort/merchants/hooks/api/PerkAccesses';
import {useCurrentMerchant} from '@cohort/merchants/hooks/contexts/currentMerchant';
import type {CohortPerkUsedVerificationAttemptData} from '@cohort/shared/schema/apps/cohort/triggers/perkUsed';

const CohortPerkUsedTriggerIntegrationStepCompletionComponent: React.FC<{
  data: CohortPerkUsedVerificationAttemptData;
}> = ({data}) => {
  const merchant = useCurrentMerchant();
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const firstPerkAccessId = data.perkUsages[0]!.accessId;
  const {data: perkAccess, isLoading} = usePerkAccess(merchant.id, firstPerkAccessId);

  return (
    <StepCompletionCard
      isLoading={isLoading}
      translationConfig={
        perkAccess !== undefined
          ? {
              // i18nOwl-ignore [app-cohort.triggerIntegrations.perk-used.stepCompletionComponent.content]
              key: 'triggerIntegrations.perk-used.stepCompletionComponent.content',
              ns: 'app-cohort',
              value: perkAccess.perk.internalName,
            }
          : null
      }
    />
  );
};

export default CohortPerkUsedTriggerIntegrationStepCompletionComponent;
